import { Link } from 'react-router-dom';

const HeroSection = () => {
  return (
    <section className="relative min-h-[90vh] flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/05f3222428c4e43a85ca808f48bb607f.jpg')`,
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center text-white w-full">
        <h1 className="text-6xl md:text-7xl font-serif font-bold mb-6 leading-tight">
          Comprendre les mouvements citoyens
        </h1>
        <p className="text-xl md:text-2xl mb-8 leading-relaxed max-w-3xl mx-auto font-light">
          Documentation, analyse et décryptage des mobilisations sociales, des enjeux démocratiques et des évolutions sociétales
        </p>
        <div className="flex flex-wrap gap-4 justify-center">
          <Link
            to="/blog"
            className="bg-white text-[#1a1a1a] px-8 py-4 rounded-lg font-semibold hover:bg-gray-100 transition-all whitespace-nowrap cursor-pointer"
          >
            Explorer les analyses
          </Link>
          <Link
            to="/notre-mission"
            className="bg-transparent border-2 border-white text-white px-8 py-4 rounded-lg font-semibold hover:bg-white/10 transition-all whitespace-nowrap cursor-pointer"
          >
            Notre mission
          </Link>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
